interface MetricPillProps {
    label: string;
    value: string;
}

const MetricPill = ({ label, value }: MetricPillProps) => (
    <div className="rounded-lg border border-zinc-800 bg-zinc-950/70 px-3 py-2">
        <div className="text-[11px] uppercase tracking-[0.16em] text-zinc-500">{label}</div>
        <div className="mt-1 text-sm font-medium text-zinc-100">{value}</div>
    </div>
);

export default MetricPill;
